// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Footermobile[data-v-c2fea0c0]{border-top:1px solid #ccc;padding:10px 0;display:flex;justify-content:center;align-items:center;background-color:#212121}.Footermobile a[data-v-c2fea0c0]{display:block;text-decoration:none;color:#ccc;cursor:pointer}", ""]);
// Exports
module.exports = exports;
